import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { HelpCircle } from 'lucide-react';

export const HelpTooltip = ({ text, side = 'top', className = '' }) => (
  <TooltipProvider delayDuration={200}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-[var(--crm-text-muted)] hover:text-[var(--crm-text-secondary)] transition-colors ${className}`}
          data-testid="help-tooltip-trigger">
          <HelpCircle className="w-3.5 h-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="bg-[var(--crm-bg-main)] border border-[var(--crm-border)] text-slate-200 text-xs max-w-[240px] px-3 py-2">
        {text}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
